import { MatDialogConfig } from '@angular/material/dialog';

export const DIALOG_FORM_CONFIG = {
    maxWidth: '95vw',
    maxHeight: '90vh',
    panelClass: 'card-dialog',
} as const;

export function dialogFormConfig(
    width?: string,
    extra?: Partial<MatDialogConfig>,
): MatDialogConfig {
    const panelClass = extra?.panelClass
        ? Array.isArray(extra.panelClass)
            ? [...new Set([...extra.panelClass, DIALOG_FORM_CONFIG.panelClass])]
            : [extra.panelClass, DIALOG_FORM_CONFIG.panelClass]
        : DIALOG_FORM_CONFIG.panelClass;

    return {
        ...DIALOG_FORM_CONFIG,
        ...(width ? { width } : {}),
        ...extra,
        panelClass,
    };
}
